// eslint-disable-next-line
const fullConfig = preval`
  const resolveConfig = require('tailwindcss/resolveConfig');
  const tailwindConfig = require('../../tailwind.config');
  module.exports = resolveConfig(tailwindConfig);
`;

const { screens = {} } = fullConfig.theme || {};

export const getBreakpointValue = value => {
  let bp = screens[value];
  if (typeof bp === 'object' && bp.min) {
    bp = bp.min;
  }
  return +bp.slice(0, bp.indexOf('px'));
};

export const getCurrentBreakpoint = () => {
  let currentBreakpoint;
  let biggestBreakpointValue = 0;
  const windowWidth = window.innerWidth;
  Object.keys(screens).forEach(breakpoint => {
    if (breakpoint === 'tall') return;

    const breakpointValue = getBreakpointValue(breakpoint);
    if (breakpointValue > biggestBreakpointValue && windowWidth >= breakpointValue) {
      biggestBreakpointValue = breakpointValue;
      currentBreakpoint = breakpoint;
    }
  });
  console.log('current breakpoint', currentBreakpoint);
  return currentBreakpoint;
};

// eslint-disable-next-line import/prefer-default-export
export const wait = sec => new Promise(resolve => setTimeout(resolve, sec * 1000));
export const noop = () => {};

export const getRandomInt = (min, max) => {
  const newMin = Math.ceil(min);
  const newMax = Math.floor(max);
  return Math.floor(Math.random() * (newMax - newMin) + newMin);
};

export const checkForMeasurementError = error =>
  Object.keys(error || {}).filter(e => parseInt(e, 10) < 10000);

export const hexStringToUint8Array = hexString => {
  if (hexString.length % 2 !== 0) return false;

  const arrayBuffer = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    const byteValue = parseInt(hexString.substring(i, i + 2), 16);
    if (Number.isNaN(byteValue)) return false;

    arrayBuffer[i / 2] = byteValue;
  }
  return arrayBuffer;
};
